import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { c2cApi } from "../../api/c2c-api";
import TopBar from "../../components/topBar";
import { getText } from "../../utils/util";
import CenterPage from "./components/centerPage";
import { AcendexLayout } from "@/components/acendex/components/layout/AcendexLayout";

export default function C2CtkList() {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const uid = localStorage.getItem("uid");
  const [list, setlist] = useState([] as any[]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  //加载数据
  const loadData = async () => {
    setLoading(true);
    setError('');
    try {
      const data = await c2cApi.czlist({ uid, type: 2 });
      if (data.ok) {
        setlist(data.data);
      } else {
        setError(translate(getText("加载数据失败")));
      }
    } catch (err) {
      setError(translate(getText("网络错误，请稍后重试")));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);
  
  return (
    <div className="w-full min-h-dvh bg-neutral-900 text-neutral-100 revert-style">
      <AcendexLayout
        theme="light"
        mobileTopBarTitle={translate(getText("C2C提款記錄"))}
        pcTopBarTitle={translate(getText("C2C提款記錄"))}
      >
        <div className="container mx-auto px-4 md:px-8 py-6 animate-fade-in">
          <div className="bg-neutral-800 rounded-lg shadow-card border border-neutral-700 overflow-hidden">
            <div className="p-4 md:p-6">
              {loading ? (
                <div className="flex justify-center items-center py-20">
                  <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
                </div>
              ) : error ? (
                <div className="text-center py-16 text-danger">
                  <p>{error}</p>
                  <button
                    onClick={loadData}
                    className="mt-4 px-4 py-2 bg-primary rounded-md text-white hover:bg-primary-dark transition-colors"
                  >
                    {translate(getText("重试"))}
                  </button>
                </div>
              ) : (
                <CenterPage list={list} />
              )}
            </div>
          </div>
        </div>
      </AcendexLayout>
    </div>
  );
}
